<template>
    <div class="modal large-modal">
        <div class="inner">
			<h2>Search {{ localSearchFor }} Products</h2>
			<div class="content">
				<div class="one-three-columns">
					<div>
						<label>UPC or Description</label>
						<input type="search" v-model="productFilters.search_term" placeholder="Search..." @search="getListProducts(true)" v-focus>
						<label>Department</label>
						<select v-model="productFilters.department_id" @change="getListProducts(true)">
							<option value="">Select...</option>
							<option v-for="(department, index) in departments" :value="department.department_id">{{ department.description }}</option>
						</select>
						<label>Category</label>
						<select v-model="productFilters.category_id" @change="getListProducts(true)" :disabled="productList.length < 1">
							<option value="">Select...</option>
							<option v-for="(category, index) in categories" :value="category.category_id">{{ category.description }}</option>
						</select>
						<div v-if="!manufacturer">
							<label>Manufacturer</label>
							<select v-model="productFilters.manufacturer_id" @change="getListProducts(true)" :disabled="productList.length < 1">
								<option value="">Select...</option>
								<option v-for="(manufacturer, index) in manufacturers" :value="manufacturer.manufacturer_id">{{ manufacturer.description }}</option>
							</select>
						</div>
						<div v-if="!getAdministratorFlag" class="v-spaced">
							<span :class="['pointer', 'far', productFilters.owner == 'store' ? 'fa-check-square' : 'fa-square']" @click="toggleProductFilter('owner')"></span>
							<label> In Store Inventory</label>
						</div>
						<div v-if="!getAdministratorFlag" class="v-spaced">
							<span :class="['pointer', 'far', productFilters.owner != 'store' ? 'fa-check-square' : 'fa-square']" @click="toggleProductFilter('owner')"></span>
							<label> Distributor Inventory</label>
						</div>
						<div class="v-spaced">
							<span :class="['pointer', 'far', productFilters.in_stock ? 'fa-check-square' : 'fa-square']" @click="toggleProductFilter('in_stock')"></span>
							<label> Currently Available</label>
						</div>
						<div class="v-spaced">
							<span :class="['pointer', 'far', !productFilters.in_stock ? 'fa-check-square' : 'fa-square']" @click="toggleProductFilter('in_stock')"></span>
							<label> Ignore Availability</label>
						</div>
					</div>
					<div>
						<div v-if="searchMessage" class="empty" style="margin: 1em 0;">
							<p v-html="searchMessage"></p>
							<p v-if="searching"><i class="fa fa-spinner fa-spin" /></p>
						</div>

						<div v-if="productList.length > 0" class="modal-search-result">
							<div class="empty" style="margin: 0 0 0.5em 0;">Click to select {{ localSingleProduct || productList.length == 1 ? 'a product' : 'products' }}...</div>
							<div v-if="productPaging.total_pages > 1" class="page-controls">
								<pagination :paging="productPaging" @updatePage="goToProductPage"></pagination>
							</div>

						    <table class="data-list" cellpadding="0" cellspacing="0">
								<thead>
									<tr>
										<th class="list"></th>
										<th class="list">Product</th>
										<th class="list">UPC</th>
										<th class="list right">Available</th>
										<th class="list right">Price</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in productList" :class="['clickable-list-item', { selected: selectedProducts.find(inList => inList.product_id == item.product_id) }]" @click="assignProduct(item)">
										<td class="list tiny-image center" style="width: 33px; height: 33px; padding: 0.25em 1em;"><img :src="item.image_src"></td>
										<td class="list">{{ item.description }}</td>
										<td class="list">{{ item.upc }}</td>
										<td class="list right">{{ item.available }}</td>
										<td class="list right">{{ $formatCurrency(item.price) }}</td>
									</tr>
								</tbody>
							</table>

							<div v-if="productPaging.total_pages > 1" class="page-controls">
								<pagination :paging="productPaging" @updatePage="goToProductPage"></pagination>
							</div>

						</div>
					</div>
				</div>
			</div>

			<div class="controls">
				<div class="button cancel spaced" @click="cancel()">Cancel</div>
				<div v-if="hasFilters" class="button neutral spaced" @click="setProductFilters(true)">Start Again</div>
				<div v-if="!localSingleProduct && hasFilters" :class="['button', selectedProducts.length > 0 ? 'action' : 'disabled', 'spaced']" @click="assignSelected()">{{ selectedProducts.length > 0 ? 'Add ' + selectedProducts.length : 'None' }} Selected</div>
			</div>
		</div>
    </div>
</template>
<script>
export default {
    name: 'product-search',
	props: ['searchFor', 'manufacturer', 'singleProduct'],
	data() {
		return {
			searching: false,
			searchMessage: '',
			productFilters: {},
            departments: [],
            categories: {},
			manufacturers: {},
			calibers: {},
			productList: [],
			productPaging: {},
			localSearchFor: '',
			localSingleProduct: false,
			selectedProducts: []
		}
	},
    created() {
        this.setProductFilters(true)
		if (this.manufacturer) {
			this.localSearchFor = this.manufacturer.description
		} else {
			this.localSearchFor = this.searchFor
		}
		if (this.singleProduct) {
			this.localSingleProduct = true
		}
    },
    computed: {
        hasFilters() {
            return this.productFilters.page > 1 || this.productFilters.owner != 'store' || this.productFilters.search_term || this.productFilters.department_id || !this.productFilters.in_stock
        }
	},
	methods: {
		setProductFilters(forceClear) {
            // TODO: store filter set in session so we can recreate list between loads
            let productSearchFilters = sessionStorage.getItem('product_search_filters')
            if (productSearchFilters) {
                let storedFilters = JSON.parse(productSearchFilters);
                this.productFilters = storedFilters.productFilters
                this.productPaging = storedFilters.productPaging
                this.productList = storedFilters.productList
                this.departments = storedFilters.departments
                this.manufacturers = storedFilters.manufacturers
                this.categories = storedFilters.categories
            }
			if (this.productList.length == 0) {
				this.searchMessage = 'Search for products by UPC or description,<br>or select a department to begin.'
			}
            if (this.departments.length == 0) {
                this.getDepartments()
            }
            if (forceClear || !productSearchFilters) {
				let localOwner = this.getAdministratorFlag ? 'distributor' : 'store'
				let localManufacturerId = this.manufacturer ? this.manufacturer.manufacturer_id : ''
                this.productFilters = {
                    page: 1,
                    owner: localOwner,
                    search_term: '',
                    department_id: '',
                    category_id: '',
                    manufacturer_id: localManufacturerId,
                    in_stock: true,
                    image_size: 'tiny'
                }
                this.productPaging = {}
                this.productList = []
                this.manufacturers = {}
                this.categories = {}
				this.searchMessage = 'Search for products by UPC or description,<br>or select a department to begin.'
				this.selectedProducts = []
			}
			if (this.getAdministratorFlag) {
				this.productFilters.owner = 'distributor'
				if (this.manufacturer.manufacturer_id) {
					this.productFilters.manufacturer_id = this.manufacturer.manufacturer_id
				}
			}
			this.storeFilters()
			if (this.manufacturer) {
				this.getListProducts(true)
			}
		},
        storeFilters() {
            let storeFilters = {}
            storeFilters.productFilters = this.productFilters
            storeFilters.productPaging = this.productPaging
            storeFilters.productList = this.productList
            storeFilters.departments = this.departments
            storeFilters.manufacturers = this.manufacturers
            storeFilters.categories = this.categories
            sessionStorage.setItem('product_search_filters', JSON.stringify(storeFilters))
        },
		getListProducts(getFilters) {
			if (this.searching) { return }
			if (!this.productFilters.search_term && !this.productFilters.department_id && !this.productFilters.manufacturer_id) { return }
			if (getFilters) {
				this.productFilters.page = 1
				this.productFilters.get_filters = true
			}
			this.productList = []
			this.searching = true
			this.searchMessage = 'Searching...'
			this.apiCall({ destination: 'get_list_products', data: this.productFilters }).then(obj => {
				this.productFilters.get_filters = false
                this.searching = false
				if (obj.status = 'success') {
					if (obj.list.length == 0) {
						this.searchMessage = 'No matching products found.'
					} else {
						this.searchMessage = ''
						this.productList = obj.list
						if (obj.pagination) {
							this.productPaging = obj.pagination
						}
						if (obj.filter_lists) {
							this.categories = obj.filter_lists.categories
							this.manufacturers = obj.filter_lists.manufacturers
							this.calibers = obj.filter_lists.calibers
						}
                    }
				} else {
					this.searchMessage = obj.message
				}
			}).catch(err => {
                this.searching = false
				this.searchMessage = err
			})
		},
		toggleProductFilter(which) {
			if (which == 'owner') {
				this.productFilters.owner = this.productFilters.owner == 'store' ? 'distributor' : 'store'
			} else {
				this.productFilters[which] = !this.productFilters[which]
				this.productFilters.ignore_availability = !this.productFilters.in_stock
			}
			if (this.productFilters.search_term || this.productFilters.department_id) {
				this.getListProducts(true)
			}
		},
		goToProductPage(page) {
			this.productFilters.page = page
			this.getListProducts()
		},
		getDepartments() {
			this.apiCall({ destination: 'get_list_departments' }).then(obj => {
				this.departments = obj.departments
			}).catch(err => {
				console.log(err)
			})
		},
		assignProduct(product) {
			if (this.productList.length == 0) { return }
			if (this.productList.length == 1 || this.singleProduct) {
				this.productList = []
				this.searchMessage = ''
				this.searching = false
    	        // this.storeFilters()
        	    this.$emit('assignProduct', product)
			}
			// is product already in selected list?
			let found = this.selectedProducts.find(item => item.product_id == product.product_id)
			if (found) {
				this.selectedProducts = this.selectedProducts.filter(item => item.product_id != product.product_id)
			} else {
				this.selectedProducts.push(product)
			}
        },
		assignSelected() {
			if (this.selectedProducts.length == 0) { return }
			for (let i = 0; i < this.selectedProducts.length; i++) {
				this.$emit('assignProduct', this.selectedProducts[i])
			}
			this.productList = []
			this.searchMessage = ''
			this.searching = false
		},
        cancel() {
            this.storeFilters()
            this.$emit('cancel')
        }
    }
}
</script>
